import storage from 'utils/storage'
import accessToken from 'utils/access-token'
import store from 'store'
import { USER_SIGNOUT } from 'utils/constant'
import UserService from 'service/user-service'

function isLogin () {
  return !!accessToken.get()
}

const login = function (back, uid) {
  if (back) {
    back = back.replace(/^https?:\/\/[\w:/?=&.]+#/, '')
    if (back !== '/') {
      storage.set('back', back, 3600)
    }
  }
  if (uid) {
    storage.set('uid', uid, 3600)
  }
  window.$router.push('/login')
}

const logout = function (back, uid) {
  UserService.logout().then(() => {
    store.commit(USER_SIGNOUT)
    login(back, uid)
  })
}

export { isLogin, login, logout }



// WEBPACK FOOTER //
// ./src/common/utils/login-util.js